import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    listForCompetition: [],
    listForCompetitionLoading: false,
    participantList: [],
    participantListLoading: false,
    registrationData: {},
    registrationDataLoading: false,
    registeredParticipants: [],
    registeredParticipantsLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setListForCompetition(state, payload) {
      state.listForCompetition = payload;
    },
    setListForCompetitionLoading(state, payload) {
      state.listForCompetitionLoading = payload;
    },
    setListForCompetitionEventNumbers(state, payload) {
      const numbersByID = {};
      payload.forEach(event => {
        numbersByID[event.id] = event.event_no;
      });
      state.listForCompetition = state.listForCompetition.map(event =>
        numbersByID[event.id] !== undefined
          ? { ...event, event_no: numbersByID[event.id] }
          : event
      );
    },
    setParticipantList(state, payload) {
      state.participantList = payload;
    },
    setParticipantListLoading(state, payload) {
      state.participantListLoading = payload;
    },
    setRegistrationData(state, payload) {
      state.registrationData = payload;
    },
    setRegistrationDataLoading(state, payload) {
      state.registrationDataLoading = payload;
    },
    setRegisteredParticipants(state, payload) {
      state.registeredParticipants = payload;
    },
    setRegisteredParticipantsLoading(state, payload) {
      state.registeredParticipantsLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("events");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("events/byID", { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadForCompetition({ commit, rootState }, id) {
      commit("setListForCompetitionLoading", true);
      let response = await api.get("events/forCompetition", {
        params: {
          id: id,
          entries: rootState.settings.siteArea == "Entries" ? true : null
        }
      });
      commit("setListForCompetition", response.data);
      commit("setListForCompetitionLoading", false);
    },
    async loadParticipantsForEvent({ commit }, id) {
      commit("setParticipantListLoading", true);
      let response = await api.get(`events/participantsForEvent`, {
        params: {
          id: id
        }
      });
      commit("setParticipantList", response.data);
      commit("setParticipantListLoading", false);
    },
    async loadRegistrationData({ commit }, id) {
      commit("setRegistrationDataLoading", true);
      let response = await api.get(`events/registrationData`, {
        params: {
          id: id
        }
      });
      commit("setRegistrationData", response.data);
      commit("setRegistrationDataLoading", false);
    },
    async loadRegisteredParticipants({ commit }, id) {
      commit("setRegisteredParticipantsLoading", true);
      let response = await api.get(`events/registeredParticipants`, {
        params: {
          id: id
        }
      });
      commit("setRegisteredParticipants", response.data);
      commit("setRegisteredParticipantsLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async addToCompetition({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/addToCompetition`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async removeFromCompetition({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/removeFromCompetition`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async updateRegistrationValue({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateRegistrationValue`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateMarshalledStatus({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateMarshalledStatus`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateCheckedInStatus({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateCheckedInStatus`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateParticipantFinished({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateParticipantFinished`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateParticipantDQCode({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateParticipantDQCode`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateParticipantPoints({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateParticipantPoints`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },

    async duplicateEvent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/duplicateEvent`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async registerAll({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/registerAll`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async marshallAll({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/marshallAll`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async publishMarshalled({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/publishMarshalled`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async checkinAll({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/checkinAll`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async publishCheckedIn({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/publishCheckedIn`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async publishResults({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/publishResults`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async resetEventProgress({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`events/resetEventProgress`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateTeamRace({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateTeamRace`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateTeamLane({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`events/updateTeamLane`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async loadAssociations({ state, commit }, events_id) {
      commit("setAssociationsListLoading", true);
      let list = await api.get("events/associations", {
        params: {
          events_id: events_id
        }
      });
      commit("setAssociationsList", list.data);
      commit("setAssociationsListLoading", false);
    },
    async combineEvent({ state, commit }, payload) {
      let returnData = {};
      await api
        .post(`events/combine`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async scratchUnscratchEvent({ state, commit }, payload) {
      let returnData = {};
      await api
        .post(`events/scratchUnscratchEvent`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async updateEventNumbers({ state, commit }, payload) {
      // Keep the store in sync straight away so the new order survives
      // tab switches (the events tab is destroyed/remounted by v-if and
      // re-sorts from this list)
      commit("setListForCompetitionEventNumbers", payload);
      let returnData = {};
      await api
        .post(`events/updateEventNumbers`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error"
          };
        });
      return returnData;
    }

  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    listForCompetition(state) {
      return state.listForCompetition;
    },
    listForCompetitionOrderedDivision(state) {
      return state.listForCompetition.sort((a, b) => {
        return a.division_id - b.division_id;
      });
    },
    listForCompetitionLoading(state) {
      return state.listForCompetitionLoading;
    },
    teamListForCompetition(state) {
      return state.listForCompetition.filter(
        e => JSON.parse(e.playerLabels).length > 1
      );
    },

    teamListForCompetitionOrderedDivision(state) {
      return state.listForCompetition
        .filter(e => JSON.parse(e.playerLabels).length > 1)
        .sort((a, b) => {
          return a.division_id - b.division_id;
        });
    },
    listForWaves(state) {
      return state.listForCompetition
        .sort((a, b) => {
          if (a.currentStep > 2 && b.currentStep < 3) {
            return 1;
          }

          if (b.currentStep > 2 && a.currentStep < 3) {
            return -1;
          }
          if (a.event_no > b.event_no) {
            return 1;
          }

          if (b.event_no > a.event_no) {
            return -1;
          }

          return 0;
        })
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
    listForWavesLoading(state) {
      return state.listForCompetitionLoading;
    },
    participantList(state) {
      return state.participantList;
    },
    participantListLoading(state) {
      return state.participantListLoading;
    },
    registrationData(state) {
      return state.registrationData;
    },
    registrationDataLoading(state) {
      return state.registrationDataLoading;
    },
    registeredParticipants(state) {
      return state.registeredParticipants;
    },
    registeredParticipantsLoading(state) {
      return state.registeredParticipantsLoading;
    }
  }
};
